import { render, staticRenderFns } from "./Loading2.vue?vue&type=template&id=3300fa35&scoped=true"
import script from "./Loading2.vue?vue&type=script&lang=js"
export * from "./Loading2.vue?vue&type=script&lang=js"
import style0 from "./Loading2.vue?vue&type=style&index=0&id=3300fa35&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3300fa35",
  null
  
)

export default component.exports